import { graphql } from "gatsby";
import React from 'react';
import Benefits from '../components/molecules/benefits/benefits';
import ProductDetailSection from '../shared/components/molecules/productDetailSection/productDetailSection';
import ProductsSections from '../shared/components/molecules/productsSections/productsSections';
import ModalRetails from "../shared/components/molecules/modal-retails/modal-retails";
import ModalPov from "../shared/components/molecules/modalPov/modalPov";
import TabProducts from '../shared/components/molecules/tabProducts/tabProducts';
import Layout from '../shared/components/organisms/layout/layout';
import SEO from '../shared/components/seo';
import useBrowserMode from '../shared/hooks/useBrowserMode';
import useMobileMode from '../shared/hooks/useMobileMode';
import useModalGeneric from '../shared/hooks/useModalGeneric';
import { stringUnicode } from '../shared/state/utils/utilities-seo';
import useHomeLinkMode from '../shared/hooks/useHomeLinkMode';
import '../shared/_shared/Index.scss'

const HomeSectionDetailProduct = props => {
  const productData = props.pageContext.product;
  const menu = props.pageContext.menu;
  const [isModal, HideModal] = useModalGeneric(false);
  const { isMobile, currentPage } = useMobileMode();
  const { isBrowser } = useBrowserMode();
  const { homeLink } = useHomeLinkMode();
  let _parentNode = isBrowser ? document.querySelector('body') : null;
  const [modalVisibility, setModalVisibility] = React.useState(false);
  const haveStoreAndSamples = props.data.allContentfulTenaHome.nodes[0];
  const newSlug = props.pageContext.parentSlug !== "/" ? props.pageContext.parentSlug : "productos"

  React.useEffect(() => {
    if (_parentNode && _parentNode.scrollTop > 0) {
      _parentNode.scroll({
        top: 0,
        behavior: 'smooth',
      })
    }
  }, []);
  let seoImg = productData.imagenProductoCompleta && productData.imagenProductoCompleta.fluid.src;
  let res = seoImg.split("?");
  seoImg = res[0];

  let schemaOrgJSONLD;
  if (productData) {

    let ratingValue = productData.ratingValue !== null ? productData.ratingValue : 5;
    let reviewCount = productData.reviewCount !== null ? productData.reviewCount : 1;

    schemaOrgJSONLD = {
      "@context": "https://schema.org/",
      "@type": "Product",
      "url": "/productos/" + props.pageContext.slug,
      "name": stringUnicode(productData.nombreProducto),
      "description": stringUnicode(productData.metaDescripcion.metaDescripcion),
      "image": seoImg,
      "sku": productData.id,
      "mpn": productData.id,
      "brand": {
        "@type": "Brand",
        "name": "TENA"
      },
      "review": {
        "@type": "Review",
        "author": {
          "@type": "Organization",
          "name": "TENA"
        }
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5",
        "reviewCount": reviewCount.toString()
      }
    };
  }
  
  return (
    <Layout title={productData.metaTitulo} white={true} isMobile={isMobile} currentPage={currentPage}>
      {productData &&
        <SEO
          title={productData.metaTitulo}
          description={productData.metaDescripcion.metaDescripcion}
          lang={props.pageContext.language}
          image={seoImg}
          slug={"/productos/" + props.pageContext.slug}
          script={schemaOrgJSONLD}
        />
      }
      <article>
        {/* <TabProducts partial={true} slug={newSlug} tabs={menu[0]} /> */}
        {productData &&
          <ProductDetailSection
            product={props.pageContext}
            isMobile={isMobile}
            title={productData.nombreProducto}
            descripcion={productData.descripcionProducto}
            numeroGotas={productData.numeroDeGotas}
            numeroGotasLlenas={productData.numeroDeGotasLlenas}
            imagenProducto={productData.imagenProductoCompleta}
            imagenesProductoSlider={productData.imagenesProductoCompletas}
            urlVideo={productData.urlVideo}
            nivelIncontinencia={productData.nivelIncontinencia}
            url={props.pageContext.slug}
            slug={props.pageContext.categoria[0].slug}
            idProduct={productData.codigoDeProducto}
            atributes={productData.sellos}
            haveRetails={props.pageContext.product.tieneRetails}
            paramRetails={props.pageContext.product.retailsDelProducto}
            setModalVisibility={setModalVisibility}
            buttonsRetails={
              productData.tieneRetails && haveStoreAndSamples.tieneMuestras ?
                props.pageContext.product.tieneBotonDeMuestraGratis
                  ?
                    [{
                      title: productData.ctaMuestraGratis,
                      slug: homeLink.slice(0, -1) + productData.redireccionMuestraGratis,
                      shop: false
                    },
                    {
                      title: props.pageContext.ctaQuieroComprar ? props.pageContext.ctaQuieroComprar : 'QUIERO COMPRAR',
                      slug: productData.redireccionComprarEnLinea,
                      shop: true
                    }]
                  :
                    [{
                      title: props.pageContext.ctaQuieroComprar ? props.pageContext.ctaQuieroComprar : 'QUIERO COMPRAR',
                      slug: productData.redireccionComprarEnLinea,
                      shop: true
                    }]
                :
                productData.tieneRetails && !haveStoreAndSamples.tieneMuestras ?
                  [{
                    title: props.pageContext.ctaQuieroComprar ? props.pageContext.ctaQuieroComprar : 'QUIERO COMPRAR',
                    slug: productData.redireccionComprarEnLinea,
                    shop: true
                  }]
                  :
                  !productData.tieneRetails && haveStoreAndSamples.tieneMuestras ?
                    props.pageContext.product.tieneBotonDeMuestraGratis
                      ?
                        [
                          null, {
                            title: productData.ctaMuestraGratis,
                            slug: homeLink.slice(0, -1) + productData.redireccionMuestraGratis,
                            shop: false
                          }
                        ]
                      : null
                    : null
            }
            beneficios={
              <Benefits
                setModalVisibility={setModalVisibility}
                haveRetails={props.pageContext.product.tieneRetails}
                paramRetails={props.pageContext.product.retailsDelProducto}
                image={{
                  title: productData.beneficiosImagen !== null ? productData.beneficiosImagen.description : '',
                  src: productData.beneficiosImagen !== null ? productData.beneficiosImagen.fluid : ''
                }}
                buttons={
                  productData.tieneRetails && haveStoreAndSamples.tieneMuestras ?
                    [{
                      title: productData.ctaMuestraGratis,
                      slug: homeLink.slice(0, -1) + productData.redireccionMuestraGratis,
                      shop: false
                    },
                    {
                      title: 'QUIERO COMPRAR',
                      slug: productData.redireccionComprarEnLinea,
                      shop: true
                    }]
                    :
                    productData.tieneRetails && !haveStoreAndSamples.tieneMuestras ?
                      [{
                        title: 'QUIERO COMPRAR',
                        slug: productData.redireccionComprarEnLinea,
                        shop: true
                      }]
                      :
                      !productData.tieneRetails && haveStoreAndSamples.tieneMuestras ?
                        [
                          null, {
                            title: productData.ctaMuestraGratis,
                            slug: homeLink.slice(0, -1) + productData.redireccionMuestraGratis,
                            shop: false
                          }
                        ]
                        : null
                }
                dataTitle={productData.tituloCaracteristicas}
                data={productData.caracteristicas}
              />}
            products={
              productData.tePuedeInteresarReferencias ?
                <ProductsSections
                  orden={productData.tipoDelUltimoDestacado}
                  isCurved={true}
                  noCenter={true}
                  noFooter={true}
                  noHeight={false}
                  titleType={'products'}
                  slug={props.pageContext.categoria[0].slug}
                  productos={productData.tePuedeInteresarReferencias ? productData.tePuedeInteresarReferencias.filter(value => value.nombreProducto) : []}
                  articulos={productData.tePuedeInteresarReferencias ? productData.tePuedeInteresarReferencias.filter(value => value.descripcionArticulo) : []}
                  title={productData.tePuedeInteresar}// aqui
                  titleInteres={props.pageContext.ctaTePuedeInteresar}
                  destacados={productData.tePuedeInteresarReferencias ? productData.tePuedeInteresarReferencias.find(value => value.elementosHtml) : {}}
                /> :
                <div className="f-no-product-section"></div>
            }
          />
        }
        {isModal && <ModalPov onClose={HideModal} />}
        {/* {
                    modalVisibility &&
                    <ModalRetails commercialPartners={commercialPartners} paramRetails={props.pageContext.product.retailsDelProducto} hideAction={() => { setModalVisibility(false) }} />
                } */}
        {
          modalVisibility &&
          <ModalRetails
            productInfo={props.pageContext.product}
            paramRetails={props.pageContext.product.retailsDelProducto}
            hideAction={() => { setModalVisibility(false) }}
          />
        }
      </article>
    </Layout>
  )
}

export default HomeSectionDetailProduct;

export const query = graphql`
  query GET_CONTENT_PRODUCT_DETAIL($language: String!) {
    allContentfulTenaHome( filter: { node_locale: { eq: $language } }) {
      nodes {
        tieneTiendas
        tieneMuestras
      }
    }
  }
`
